import React, { useEffect, useState } from "react";
import axios from "src/config/axios";
import {
  Accordion,
  Button,
  Card,
  Col,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import { dateFormatter, dateTimeFormatter } from "src/global";

const LocalTaxDailyReportDetailsDialog = ({
  reportId,
  handleClose,
  statusLabel,
}) => {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    setLoading(true);
    setErrorMessage(null);

    axios
      .get("/api/v1/local_tax_daily_reports/" + reportId + ".json")
      .then(({ data }) => {
        setReport(data);
      })
      .catch((error) => {
        console.error(error);
        setErrorMessage("Details konnten nicht geladen werden.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [reportId]);

  function formatPayload(payload) {
    if (!payload) return "-";

    return JSON.stringify(payload, null, 2);
  }

  return (
    <Modal show={true} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Details LTS Tagesmeldung</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && (
          <Spinner
            className="d-block mx-auto"
            animation="border"
            variant="primary"
          />
        )}

        {errorMessage && (
          <div className="alert alert-danger">{errorMessage}</div>
        )}

        {!loading && report && (
          <>
            <Row>
              <Col md={6} xs={12}>
                <p>
                  <strong>Datum:</strong> {dateFormatter(report.report_date)}
                </p>
                <p>
                  <strong>Anreisen:</strong> {report.arrivals_count ?? "-"}
                </p>
                <p>
                  <strong>Abreisen:</strong> {report.departures_count ?? "-"}
                </p>
              </Col>
              <Col md={6} xs={12}>
                <p>
                  <strong>Status:</strong> {statusLabel(report.status)}
                </p>
                <p>
                  <strong>Letzte Meldung:</strong>{" "}
                  {report.reported_at
                    ? dateTimeFormatter(report.reported_at)
                    : "-"}
                </p>
                <p>
                  <strong>Belegte Einheiten:</strong>{" "}
                  {report.occupied_units ?? "-"}
                </p>
                <p>
                  <strong>Verfügbare Einheiten:</strong>{" "}
                  {report.available_units ?? "-"}
                </p>
              </Col>
            </Row>

            {report.error_message && (
              <div className="alert alert-danger">
                <strong>Fehler:</strong> {report.error_message}
              </div>
            )}

            <Accordion className="mt-3">
              <Card>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey="request_payload"
                  className="cursor-pointer"
                >
                  Request Payload
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="request_payload">
                  <Card.Body>
                    <pre
                      className="bg-light p-3 border rounded mb-0"
                      style={{ maxHeight: "400px", overflow: "auto" }}
                    >
                      {formatPayload(report.request_payload)}
                    </pre>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>

              <Card>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey="response_payload"
                  className="cursor-pointer"
                >
                  Response Payload
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="response_payload">
                  <Card.Body>
                    <pre
                      className="bg-light p-3 border rounded mb-0"
                      style={{ maxHeight: "400px", overflow: "auto" }}
                    >
                      {formatPayload(report.response_payload)}
                    </pre>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Schließen
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LocalTaxDailyReportDetailsDialog;
